import React from "react";
import { useMutation } from "@apollo/client";
import { Link } from "react-router-dom";
import { Formik, Form, Field } from "formik";

import history from "./../../history";
import client from "client";
import Heading from "components/Elements/Heading.js";

import { UPDATE_SOURCE, DELETE_SOURCE } from "pages/SourcePage/SourcesQueries";
import { AddSourceValidationSchema } from "pages/SourcePage/SourceValidationSchema";

const SourceUpdateContainer = (props) => {
  const [sourcesDelete] = useMutation(DELETE_SOURCE, {
    client,
    variables: {
      tenantID: parseInt(localStorage.defaultTenantID),
    },
  });
  const [sourcesUpdate, { loading }] = useMutation(UPDATE_SOURCE, {
    client,
    variables: {
      tenantID: parseInt(localStorage.defaultTenantID),
    },
  });

  const name = props.match.params.name;
  const id = props.match.params.id;

  return (
    <div className="container-wrapper">
      <div className="container-fluid">
        <main className="container-main">
          <Link to="/settings/sources">
            {" "}
            <i className="fas fa-chevron-circle-left" /> Back
          </Link>

          <Heading size={3} className={"mb-4 mt-4"}>
            Update Source
          </Heading>

          <div className="row">
            <div className="col-6">
              <Formik
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={AddSourceValidationSchema}
                onSubmit={async (
                  values,
                  { setSubmitting, setStatus, resetForm }
                ) => {
                  setStatus(undefined);
                  let formData = { ...values, id: id };
                  try {
                    await sourcesUpdate({ variables: formData });

                    resetForm({ name: "" });
                    setStatus({
                      confirmation: `Source ${values.name} has been updated`,
                    });

                    setSubmitting(false);
                  } catch (err) {
                    setSubmitting(false);
                  }
                }}
                initialValues={{
                  name: name,
                }}
              >
                {({ errors, status, touched, isSubmitting }) => (
                  <Form>
                    {status && status.confirmation && (
                      <div className="alert alert-success" role="alert">
                        {status.confirmation}
                      </div>
                    )}
                    <div className="form-group">
                      <label htmlFor="firstName">Name</label>
                      <Field
                        id="name"
                        type="text"
                        name="name"
                        placeholder="Source Name"
                        className="form-control"
                      />

                      {status && status.name ? (
                        <div className="invalid-feedback d-block">
                          {status.name}
                        </div>
                      ) : (
                        errors.name &&
                        touched.name && (
                          <div className="invalid-feedback d-block">
                            {errors.name}
                          </div>
                        )
                      )}
                    </div>

                    <div className="form-group">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {loading ? "Updating Source..." : "Update Source"}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>

              <hr className="mt-5 mb-5" />
              <Heading size={3} className={"mb-4 mt-4"}>
                Delete Source
              </Heading>
              <p>Deleting a source will remove all of its data.</p>

              <Formik
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={async ({ setSubmitting }) => {
                  let result = window.confirm(
                    "Are you sure you want to delete this source?"
                  );

                  if (result) {
                    const confirmation = await sourcesDelete({
                      variables: {
                        id: id,
                      },
                    });
                    if (confirmation.data.sourcesDelete) {
                      history.push(`/settings/sources?source=${name}`);
                    }
                  }
                }}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <button
                      className="btn btn-danger btm-sm"
                      disabled={isSubmitting}
                      type="submit"
                    >
                      {isSubmitting ? "Deleting Source" : "Delete Source"}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SourceUpdateContainer;
